const styles = `:host {
  --goto-icon-color: var(--goto-interactive-01);
  color: var(--goto-text-01);
  padding-left: 0;
  padding-right: 18px;
  border-radius: 0;
  margin: 0;
  border: none;
  background: var(--goto-surface-color-default);
  height: var(--chameleon-select-height);
}
:host .start {
  display: block;
  box-sizing: border-box;
  margin-right: 12px;
}
:host .content {
  margin-left: 16px;
  flex-grow: 1;
}
:host .start + .content {
  margin-left: 0;
}
:host ::slotted([slot=start]) {
  margin-inline-end: 0;
  margin-left: 16px;
}
:host ::slotted(chameleon-svg[slot=start]) {
  margin-inline-end: 0;
  margin-left: 12px;
}
:host ::slotted([slot=end]) {
  margin-inline-start: 0;
}

:host(:not([disabled])[aria-selected=true]:hover) {
  background: var(--goto-option-background-hover);
  color: var(--goto-type-color-default);
}

:host(:not([disabled]):not([aria-selected=true]):hover) {
  background: var(--goto-option-background-hover);
  color: var(--goto-option-color-selected);
}

:host([disabled]),
:host([disabled]:hover) {
  --goto-icon-color: var(--goto-option-icon-color-disabled);
  opacity: 1;
  color: var(--goto-option-color-disabled);
}

:host([aria-selected=true]) {
  --goto-icon-color: var(--goto-option-icon-color-selected);
  background: var(--goto-option-background-selected);
  color: var(--goto-option-color-selected);
}`; export default styles;